import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { Store } from '@ngrx/store';
import { COMPANY_INFO } from 'apps/ff-frontend/src/app/state/app.state';

@Component({
  selector: 'with-link',
  templateUrl: './with-link.component.html',
  styleUrls: ['./with-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule,
  ]
})
export class WithLinkComponent  {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)
  keyName!: string ;
  value!:any;
  uri:string;
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }

  constructor( private store: Store,private router :Router) {
    this.store.select(COMPANY_INFO).subscribe((companyInfo)=>{
      
    })
   }

  onGoToRoute(url:string, columnData:any, canRedirect:boolean= true){
    if(url && canRedirect)
    this.router.navigate([url, columnData.id || columnData.campaign_id]);
    else
      this.onAction.emit({action:'edit',columnData});
  }
}
